import GetCmsContent from '@/graphql/CMSContent/GetCmsContent.gql'
import UpdateCmsContent from '@/graphql/CMSContent/UpdateCmsContent.gql'
import SaveCmsContent from '@/graphql/CMSContent/SaveCmsContent.gql'
import UpdateCmsContentStatus from '@/graphql/CMSContent/UpdateCmsContentStatus.gql'
import GetCmsPages from '@/graphql/CMSContent/GetCmsPages.gql'
import UpdateCmsPageStatus from '@/graphql/CMSContent/UpdateCmsPageStatus.gql'
import CreateCmsPage from '@/graphql/CMSContent/CreateCmsPage.gql'
import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getCmsContent ({ dispatch, commit }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetCmsContent,
        fetchPolicy: 'no-cache'
      })
      return response.data.getCmsContent
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },
  async updateCmsContentStatus ({ dispatch, commit }, contentId) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateCmsContentStatus,
        fetchPolicy: 'no-cache',
        variables: {
          contentId
        }
      })
      if (response.data.updateCmsContentStatus.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Contenido actualizado' })
      }
      return response.data.updateCmsContentStatus
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },

  async updateCmsContent ({ dispatch, commit }, { contentId, content }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateCmsContent,
        fetchPolicy: 'no-cache',
        variables: {
          contentId,
          content
        }
      })
      if (response.data.updateCmsContent.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Estatus actualizado' })
      }
      return response.data.updateCmsContent
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },

  async saveCmsContent ({ dispatch, commit }, { name, contentType, content }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: SaveCmsContent,
        fetchPolicy: 'no-cache',
        variables: {
          name,
          contentType,
          content
        }
      })
      if (response.data.saveCmsContent.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Nuevo contenido guardado' })
      }
      return response.data.saveCmsContent
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },
  async getCmsPages ({ dispatch, commit }, { pageNumber = 1, perPage }) {
    try {
      const response = await apollo.defaultClient.query({
        query: GetCmsPages,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber,
          perPage
        }
      })
      return response.data.getCmsPages
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },
  async updateCmsPageStatus ({ dispatch, commit }, cmsPageId) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: UpdateCmsPageStatus,
        fetchPolicy: 'no-cache',
        variables: {
          cmsPageId
        }
      })
      if (response.data.updateCmsPageStatus.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Estatus actualizado' })
      }
      return response.data.updateCmsPageStatus
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  },
  async createCmsPage ({ dispatch, commit }, { name }) {
    try {
      const response = await apollo.defaultClient.mutate({
        mutation: CreateCmsPage,
        fetchPolicy: 'no-cache',
        variables: {
          name
        }
      })
      if (response.data.createCmsPage.success) {
        dispatch('addTemporalNotification', { type: 'success', message: 'Nuevo contenido guardado' })
      }
      return response.data.createCmsPage
    } catch (err) {
      dispatch('showError', err)
      return { success: false }
    }
  }
}
